import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useRef, useEffect } from "react";
import "./UserForm.css";
import { useNavigate } from "react-router-dom";
import "../Responsive/TableResponsive.css";
import "../Responsive/FormResponsive.css";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import Select from "react-select";
import { useContext } from "react";
import { ThemeContext } from "../../src/ThemeContext";
import DatePicker from "react-datepicker";
import "./voyageForm.css";
import { MdDeleteOutline } from "react-icons/md";
import Tooltip from "@mui/material/Tooltip";
import { FiUpload } from "react-icons/fi";
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { Chip } from "@mui/material";

function VoyageForm({ isSidebarExpanded }) {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const [voyageData, setVoyageData] = useState({
    voyage_number: "",
    date: null,
    trip_number: "",
  });
  const popupRef = useRef(null);
  const [selectedFuels, setSelectedFuels] = useState({
    ATF: false,
    MS: false,
    HSD: false,
  });

  const [addedTags, setAddedTags] = useState([]);
  const [addedTagsMS, setAddedTagsMS] = useState([]);
  const [addedTagsHSD, setAddedTagsHSD] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);
  const [tagOptionsMS, setTagOptionsMS] = useState([]);
  const [tagOptionsHSD, setTagOptionsHSD] = useState([]);
  const [selectedTagNo, setSelectedTagNo] = useState(null);
  const [selectedTagNoMS, setSelectedTagNoMS] = useState(null);
  const [selectedTagNoHSD, setSelectedTagNoHSD] = useState(null);
  const [dynamicRefs, setDynamicRefs] = useState({});

  const handleTagNoChange = (selectedOption) => {
    setSelectedTagNo(selectedOption);
    if (selectedOption) {
      setAddedTags((prevTags) => {
        const fullLabel = selectedOption.label;
        const tagNoExtracted = fullLabel.split("-").pop().trim();
        const categoryExtracted = fullLabel.split("-")[0].trim();

        const updatedTags = [
          ...prevTags,
          {
            tagNo: fullLabel, // Full label
            id: selectedOption.value,
            tag_no: tagNoExtracted,
            category: categoryExtracted,
          },
        ];
        return updatedTags;
      });

      // Remove the selected tag from tagOptions to avoid duplicates
      setTagOptions((prevOptions) =>
        prevOptions.filter((option) => option.value !== selectedOption.value)
      );

      // Clear selection
      setSelectedTagNo(null);
    } else {
      console.log("No tag selected.");
    }
  };

  const handleRemoveTag = (tagId) => {
    const removedTag = addedTags.find((tag) => tag.id === tagId);

    setAddedTags((prevTags) => prevTags.filter((tag) => tag.id !== tagId));

    setTagOptions((prevOptions) => [
      ...prevOptions,
      {
        value: removedTag.id,
        label: removedTag.tagNo,
        tag_no: removedTag.tag_no,
        category: removedTag.category,
      },
    ]);

    // Clean up document states for the removed tank
    const tankIdentifier = removedTag.tag_no || removedTag.id;
    const dynamicKey = `bftReport_${tankIdentifier}`;
    const capitalized =
      dynamicKey.charAt(0).toUpperCase() + dynamicKey.slice(1);

    setDocumentStates((prevStates) => {
      const newStates = { ...prevStates };
      delete newStates[`selected${capitalized}Files`];
      delete newStates[`is${capitalized}PopupOpen`];
      return newStates;
    });

    // Clean up dynamic refs
    setDynamicRefs((prevRefs) => {
      const newRefs = { ...prevRefs };
      delete newRefs[dynamicKey];
      return newRefs;
    });
  };

  const handleRemoveTagMS = (tagId) => {
    const removedTag = addedTagsMS.find((tag) => tag.id === tagId);

    setAddedTagsMS((prevTags) => prevTags.filter((tag) => tag.id !== tagId));
    setTagOptionsMS((prevOptions) => [
      ...prevOptions,
      {
        value: removedTag.id,
        label: removedTag.tagNo,
        tag_no: removedTag.tag_no,
        category: removedTag.category,
      },
    ]);
  };

  const handleRemoveTagHSD = (tagId) => {
    const removedTag = addedTagsMS.find((tag) => tag.id === tagId);
    setAddedTagsHSD((prevTags) => prevTags.filter((tag) => tag.id !== tagId));

    setTagOptionsHSD((prevOptions) => [
      ...prevOptions,
      {
        value: removedTag.id,
        label: removedTag.tagNo,
        tag_no: removedTag.tag_no,
        category: removedTag.category,
      },
    ]);
  };

  const handleTagNoChangeMS = (selectedOption) => {
    setSelectedTagNoMS(selectedOption);

    if (selectedOption) {
      const fullLabel = selectedOption.label; // e.g., "MS Tank - T002"
      const tagNoExtracted = fullLabel.split("-").pop().trim(); // → "T002"
      const categoryExtracted = fullLabel.split("-")[0].trim(); // → "MS Tank"

      setAddedTagsMS((prevTags) => {
        // Prevent duplicate tags
        const alreadyExists = prevTags.some(
          (tag) => tag.id === selectedOption.value
        );
        if (alreadyExists) return prevTags;

        const updatedTags = [
          ...prevTags,
          {
            tagNo: fullLabel,
            id: selectedOption.value,
            tag_no: tagNoExtracted,
            category: categoryExtracted,
          },
        ];

        console.log("Updated MS Tags:", updatedTags);
        return updatedTags;
      });

      // Remove selected tank from dropdown options to avoid reselecting
      setTagOptionsMS((prevOptions) =>
        prevOptions.filter((option) => option.value !== selectedOption.value)
      );

      // Clear the dropdown
      setSelectedTagNoMS(null);
    } else {
      console.log("No MS tag selected.");
    }
  };

  const handleTagNoChangeHSD = (selectedOption) => {
    setSelectedTagNoHSD(selectedOption);

    if (selectedOption) {
      const fullLabel = selectedOption.label;
      const tagNoExtracted = fullLabel.split("-").pop().trim();
      const categoryExtracted = fullLabel.split("-")[0].trim();

      setAddedTagsHSD((prevTags) => {
        const alreadyExists = prevTags.some(
          (tag) => tag.id === selectedOption.value
        );
        if (alreadyExists) return prevTags;

        const updatedTags = [
          ...prevTags,
          {
            tagNo: fullLabel,
            id: selectedOption.value,
            tag_no: tagNoExtracted,
            category: categoryExtracted,
          },
        ];
        return updatedTags;
      });

      // Remove selected tank from dropdown options to avoid reselecting
      setTagOptionsHSD((prevOptions) =>
        prevOptions.filter((option) => option.value !== selectedOption.value)
      );

      // Clear the dropdown
      setSelectedTagNoHSD(null);
    } else {
      console.log("No MS tag selected.");
    }
  };

  // const fetchOptions = async () => {
  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const response = await axios.get(`${API_URL}/api/atf/tanks`, {
  //       headers: {
  //         Authorization: authKey,
  //       },
  //     });

  //     const optionsData = response?.data.map((item) => ({
  //       value: item.id,
  //       label: `${item.Category} - ${item.tag_no}`,
  //     }));
  //     setTagOptions(optionsData);
  //     setTagOptionsMS(optionsData);
  //     setTagOptionsHSD(optionsData);

  //     // Handle the case where no options are returned
  //     if (optionsData.length === 0) {
  //       console.warn("No options available from API");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching options:", error);
  //   }
  // };

  const fetchOptions = async (tankCategory) => {
    try {
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/atf/tanks`, {
        headers: { Authorization: authKey },
        params: { category: tankCategory },
      });

      const optionsData = response?.data.map((item) => ({
        value: item.id,
        label: `${item.Category} - ${item.tag_no}`,
      }));

      if (tankCategory === "ATF Tank") setTagOptions(optionsData);
      if (tankCategory === "MS Tank") setTagOptionsMS(optionsData);
      if (tankCategory === "HSD Tank") setTagOptionsHSD(optionsData);
    } catch (error) {
      console.error(`Error fetching ${tankCategory} options:`, error);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  // const handleCheckboxChange = (e) => {
  //   const { name, checked } = e.target;
  //   setSelectedFuels((prev) => ({
  //     ...prev,
  //     [name]: checked,
  //   }));
  // };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    // Update checkbox state
    setSelectedFuels((prev) => ({
      ...prev,
      [name]: checked,
    }));

    // If just checked, fetch tanks for that type
    if (checked) {
      if (name === "ATF") fetchOptions("ATF Tank");
      if (name === "MS") fetchOptions("MS Tank");
      if (name === "HSD") fetchOptions("HSD Tank");
    } else {
      // If unchecked, you can optionally clear the options
      if (name === "ATF") setTagOptions([]);
      if (name === "MS") setTagOptionsMS([]);
      if (name === "HSD") setTagOptionsHSD([]);
    }
  };

  const { theme } = useContext(ThemeContext);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSaveClick();
    }
  };

  const handleInputChange = (event, index = null, field = null) => {
    const { name, value } = event.target;

    setVoyageData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevState) => ({
      ...prevState,
      [name]: "", // Clear the error message for this field
    }));
  };

  const handleCancelClick = () => {
    navigate("/voyages");
  };

  const handleSaveClick = async () => {
    const newErrors = {};
    let error = false;

    // Validation
    if (!voyageData.voyage_number.trim()) {
      newErrors.voyage_number = "Voyage Number is required";
      error = true;
    }

    if (!voyageData.date) {
      newErrors.date = "Voyage Date is required";
      error = true;
    }

    if (!voyageData.trip_number.trim()) {
      newErrors.trip_number = "Trip Number is required";
      error = true;
    }

    if (error) {
      setErrors(newErrors);
      setSeverity("warning");
      showSnackbar("Please fix the validation errors.");
      return;
    }

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const formData = new FormData();
      const MAX_FILE_SIZE_MB = 10;

      let isValid = true;
      const isFileSizeValid = (file) =>
        file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

      const processFiles = (files, formDataKey) => {
        for (const fileDetail of files) {
          const file = fileDetail.file;
          if (file) {
            if (!isFileSizeValid(file)) {
              isValid = false;
              setSeverity("error");
              showSnackbar(
                `File "${file.name}" must be 10 MB or less. Please upload a smaller file.`
              );
              return;
              // setIsLoading(false);
              // throw new Error("File size validation failed");
            }
            formData.append(formDataKey, file);
          }
        }
      };

      const formattedDate = new Date(voyageData.date)
        .toISOString()
        .split("T")[0];
      formData.append("voyage_number", voyageData.voyage_number);
      formData.append("date", formattedDate);
      formData.append("trip_number", voyageData.trip_number);

      // Append selected products
      const selectedProducts = Object.keys(selectedFuels).filter(
        (fuel) => selectedFuels[fuel]
      );
      selectedProducts.forEach((product) => {
        formData.append("product", product);
      });

      // Prepare Tank data
      const prepareProductsTankData = () => {
        const result = {};
        (addedTags || []).forEach((tag) => {
          const product = tag.product || tag.Product || "ATF";
          const tank_value = tag?.category;
          const tag_no_value = tag?.tag_no;

          if (!result[product]) result[product] = [];
          result[product].push({ tank_name: tank_value, tag_no: tag_no_value });
        });
        return result;
      };

      const prepareMsProductTanks = () => {
        const result = {};
        (addedTagsMS || []).forEach((tag) => {
          const product = "MS";
          const tank_value = tag?.category;
          const tag_no_value = tag?.tag_no;
          if (!result[product]) result[product] = [];
          result[product].push({ tank_name: tank_value, tag_no: tag_no_value });
        });
        return result;
      };

      const prepareHsdProductTanks = () => {
        const result = {};
        (addedTagsHSD || []).forEach((tag) => {
          const product = "HSD";
          const tank_value = tag?.category;
          const tag_no_value = tag?.tag_no;

          if (!result[product]) result[product] = [];
          result[product].push({ tank_name: tank_value, tag_no: tag_no_value });
        });
        return result;
      };

      const productsTankData = {
        ...prepareProductsTankData(),
        ...prepareMsProductTanks(),
        ...prepareHsdProductTanks(),
      };

      formData.append("product_tanks", JSON.stringify(productsTankData));

      // --- Handle static ATF documents (excluding bft_report) ---
      for (const docType of Object.keys(documentTypes)) {
        if (docType === "bft_report") continue;
        const selectedFiles = getSelectedFiles(docType);
        processFiles(selectedFiles, docType);
      }

      // --- Handle dynamic ATF BFT documents ---
      (addedTags || []).forEach((tag) => {
        const tankIdentifier = tag.tag_no || tag.id;
        const tankDocType = `atf_bft_report_${tankIdentifier}`;
        const dynamicKey = `bftReport_${tankIdentifier}`;
        const config = {
          key: dynamicKey,
          label: `ATF BFT Report - ${tag.tagNo}`,
        };
        const selectedFiles = getSelectedFiles(tankDocType, config);
        processFiles(selectedFiles, tankDocType);
      });

      // --- Handle static MS and HSD documents (excluding bft_report) ---
      for (const [product, docs] of Object.entries(documentUploadMap)) {
        const state = product === "ms" ? uploadStateMS : uploadStateHSD;
        for (const docType of Object.keys(docs)) {
          if (docType.includes("bft_report")) continue;
          const key = docs[docType].key;
          const selectedKey = `selected${
            key.charAt(0).toUpperCase() + key.slice(1)
          }Files`;
          const selectedFiles = state[selectedKey] || [];
          processFiles(selectedFiles, docType);
        }
      }

      // --- Handle dynamic MS BFT uploads ---
      (addedTagsMS || []).forEach((tag) => {
        const tankIdentifier = tag.tag_no || tag.tagNo || tag.id; // More robust identifier
        const tankDocType = `ms_bft_report_${tankIdentifier}`;
        const dynamicKey = `msBftReport_${tankIdentifier}`;

        const config = {
          key: dynamicKey,
          label: `MS BFT Report - ${tag.tagNo || tankIdentifier}`,
        };

        const selectedFiles = getSelectedFilesMS(tankDocType, config);

        if (selectedFiles && selectedFiles.length > 0) {
          processFiles(selectedFiles, tankDocType);
        }
      });

      // --- Handle dynamic HSD BFT uploads ---
      (addedTagsHSD || []).forEach((tag) => {
        const tankIdentifier = tag.tag_no || tag.tagNo || tag.id; // More robust identifier
        const tankDocType = `hsd_bft_report_${tankIdentifier}`;
        const dynamicKey = `hsdBftReport_${tankIdentifier}`;

        const config = {
          key: dynamicKey,
          label: `HSD BFT Report - ${tag.tagNo || tankIdentifier}`,
        };

        const selectedFiles = getSelectedFilesHSD(tankDocType, config);
        if (selectedFiles && selectedFiles.length > 0) {
          processFiles(selectedFiles, tankDocType);
        }
      });

      // --- Handle common documents (Travel, Tanker) ---
      for (const [category, docs] of Object.entries(documentUploadMapCommon)) {
        const state =
          category === "travel"
            ? uploadStateTravel
            : category === "tanker"
            ? uploadStateTanker
            : null;

        if (!state) continue;

        for (const docType of Object.keys(docs)) {
          const key = docs[docType].key;
          const selectedKey = `selected${
            key.charAt(0).toUpperCase() + key.slice(1)
          }Files`;
          const selectedFiles = state[selectedKey] || [];
          processFiles(selectedFiles, docType);
        }
      }

      for (let [key, value] of formData.entries()) {
        console.log(key, value instanceof File ? `File: ${value.name}` : value);
      }

      if (!isValid) {
        setIsLoading(false);
        return;
      }
      // Submit
      const response = await axios.post(`${API_URL}/api/atf/voyage`, formData, {
        headers: {
          Authorization: authKey,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status >= 200 && response.status < 300) {
        setSeverity("success");
        showSnackbar("Voyage added successfully");
        setTimeout(() => {
          navigate("/voyages");
        }, 1000);
      } else {
        setSeverity("error");
        showSnackbar("Failed to add Voyage");
      }
    } catch (error) {
      console.error("Error saving Voyage:", error?.response?.data?.message);
      setSeverity("error");

      // ✅ Try to get backend message
      const backendMessage = error?.response?.data?.message;

      if (backendMessage) {
        showSnackbar(backendMessage);
      } else {
        showSnackbar(error.message || "Error saving voyage");
      }
      // showSnackbar("Error saving voyage");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleDateChange = (date) => {
    setVoyageData((prev) => ({
      ...prev,
      date: date,
    }));

    // Clear the error for date
    setErrors((prevErrors) => ({
      ...prevErrors,
      date: "",
    }));
  };

  const today = new Date();

  // -------ATF FILE UPLOAD ---------

  const documentTypes = {
    atf_load_port_doc: {
      label: "Load Port Test Report",
      key: "loadPortTest",
    },
    atf_pd_test: {
      label: "PD Test",
      key: "pdTest",
    },
    bft_report: {
      label: "BFT Report",
      key: "bftReport",
    },
    av2_report: {
      label: "AV2 Reports",
      key: "av2Reports",
    },
    test_h: {
      label: "Test H",
      key: "testH",
    },
  };

  const initializeDocumentStates = (
    addedTags = [],
    preserveExisting = false
  ) => {
    const states = preserveExisting
      ? {}
      : {
          // Initialize static document states only if not preserving
          ...Object.keys(documentTypes).reduce((acc, docType) => {
            const key = documentTypes[docType].key;
            const capitalized = key.charAt(0).toUpperCase() + key.slice(1);
            acc[`selected${capitalized}Files`] = [];
            acc[`is${capitalized}PopupOpen`] = false;
            return acc;
          }, {}),
        };

    // 2. Dynamic tank-specific BFT states
    addedTags.forEach((tag) => {
      const tagId = tag.tag_no || tag.id;
      const dynamicKey = `bftReport_${tagId}`;
      const capitalized =
        dynamicKey.charAt(0).toUpperCase() + dynamicKey.slice(1);

      // Only initialize if keys don't already exist
      const selectedKey = `selected${capitalized}Files`;
      const popupKey = `is${capitalized}PopupOpen`;

      if (!states.hasOwnProperty(selectedKey)) {
        states[selectedKey] = [];
      }
      if (!states.hasOwnProperty(popupKey)) {
        states[popupKey] = false;
      }
    });

    return states;
  };

  const [documentStates, setDocumentStates] = useState(() =>
    initializeDocumentStates(addedTags, false)
  );

  useEffect(() => {
    setDocumentStates((prevStates) => {
      // Only add states for tanks that don't already exist
      const updatedStates = { ...prevStates };

      addedTags.forEach((tag) => {
        const tagId = tag.tag_no || tag.id;
        const dynamicKey = `bftReport_${tagId}`;
        const capitalized =
          dynamicKey.charAt(0).toUpperCase() + dynamicKey.slice(1);

        const selectedKey = `selected${capitalized}Files`;
        const popupKey = `is${capitalized}PopupOpen`;

        // Only add if the key doesn't exist (new tank)
        if (!updatedStates.hasOwnProperty(selectedKey)) {
          updatedStates[selectedKey] = [];
        }
        if (!updatedStates.hasOwnProperty(popupKey)) {
          updatedStates[popupKey] = false;
        }
      });

      return updatedStates;
    });
  }, [addedTags]);

  const loadPortTestRef = useRef(null);
  const pdTestRef = useRef(null);
  const bftReportRef = useRef(null);
  const tankerDocsRef = useRef(null);
  const testHRef = useRef(null);
  const av2ReportsRef = useRef(null);

  // --- 2 ---
  const createRefForTank = (key) => {
    setDynamicRefs((prev) => {
      if (!prev[key]) {
        return {
          ...prev,
          [key]: React.createRef(),
        };
      }
      return prev;
    });
  };

  const getTotalFileCount = (docType, overrideConfig = null) => {
    if (overrideConfig) {
      // For dynamic tank uploads, use the config key directly
      const key = overrideConfig.key;
      const selectedKey = `selected${
        key.charAt(0).toUpperCase() + key.slice(1)
      }Files`;
      return documentStates[selectedKey]
        ? documentStates[selectedKey].length
        : 0;
    } else {
      // For static document types, use existing logic
      const key = documentTypes[docType].key;
      const selectedKey = `selected${
        key.charAt(0).toUpperCase() + key.slice(1)
      }Files`;
      return documentStates[selectedKey]
        ? documentStates[selectedKey].length
        : 0;
    }
  };

  // ---2
  const togglePopup = (docType, overrideConfig = null) => {
    const key = overrideConfig
      ? overrideConfig.key
      : documentTypes[docType]?.key;

    if (!key) return;

    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;
    setDocumentStates((prev) => ({
      ...prev,
      [popupKey]: !prev[popupKey],
    }));
  };

  // ---2
  const isPopupOpen = (docType, overrideConfig = null) => {
    const key = overrideConfig
      ? overrideConfig.key
      : documentTypes[docType]?.key;

    if (!key) return false;

    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;
    return documentStates[popupKey] || false;
  };

  const closePopup = (docType, overrideConfig = null) => {
    const config = overrideConfig || documentTypes[docType];
    if (!config) return;

    const key = config.key;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;

    setDocumentStates((prev) => ({
      ...prev,
      [popupKey]: false,
    }));
  };

  const fileInputRefs = {
    // tankerLoadPort: tankerLoadPortRef,
    loadPortTest: loadPortTestRef,
    pdTest: pdTestRef,
    bftReport: bftReportRef,
    testH: testHRef,
    tankerDocs: tankerDocsRef,
    av2Reports: av2ReportsRef,
    ...dynamicRefs,
  };

  const renderUploadSection = (docType, overrideConfig = null) => {
    const config = overrideConfig || documentTypes[docType];
    if (!config) return null; // safeguard

    const key = config.key;

    // Create ref for dynamic tank uploads
    if (overrideConfig && !fileInputRefs[key]) {
      createRefForTank(key);
    }

    const totalFiles = getTotalFileCount(docType, overrideConfig);
    const selectedFiles = getSelectedFiles(docType, overrideConfig);

    return (
      <div key={docType} className="upload-section form-group">
        <label
          htmlFor={`${key}-input`}
          className="upload-label"
          style={{ width: "auto" }}
        >
          {config.label} :
        </label>

        <div className="upload-controls">
          <button
            type="button"
            className="challan-btn"
            // onClick={() => handleUploadClick(docType)}
            onClick={() => handleUploadClick(docType, overrideConfig)}
          >
            <FiUpload className="upload-icon" /> Upload File
          </button>

          <input
            id={`${key}-input`}
            type="file"
            ref={fileInputRefs[key]}
            className="upload-hidden-input"
            // onChange={(e) => handleFileChange(docType, e)}
            onChange={(e) => handleFileChange(docType, e, overrideConfig)}
            multiple
          />

          {totalFiles > 0 && (
            <span
              className="inquiry-file-btn"
              // onClick={() => togglePopup(docType)}
              onClick={() => togglePopup(docType, overrideConfig)}
            >
              <MdAttachFile className="file-icon" />
              {totalFiles}
            </span>
          )}
        </div>

        {isPopupOpen(docType, overrideConfig) && (
          <div className="attachment-popup" ref={popupRef}>
            <div className="popup-content">
              <div className="popup-header">
                <h4 className="popup-title">
                  Attachments {overrideConfig ? `- ${config.label}` : ""}
                </h4>
                <button
                  className="popup-close-btn"
                  // onClick={() => closePopup(docType)}
                  onClick={() => closePopup(docType, overrideConfig)}
                >
                  <IoCloseOutline className="close-icon" />
                </button>
              </div>

              <div className="popup-body">
                {selectedFiles.map((file, index) => (
                  <div className="file-item" key={`selected-${index}`}>
                    <div className="file-info">
                      <p className="file-name">{file.name}</p>
                      <p className="file-size">
                        File Size: {(file.size / 1024).toFixed(2)} KB
                      </p>
                    </div>
                    <div className="file-actions">
                      <Tooltip title="Delete" arrow>
                        <button
                          className="file-action-btn remove-btn"
                          onClick={() =>
                            handleDeleteFile(docType, index, false)
                          }
                        >
                          <MdDeleteOutline className="action-icon" />
                        </button>
                      </Tooltip>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleFileChange = (docType, event, overrideConfig = null) => {
    const config = overrideConfig || documentTypes[docType];
    if (!config) {
      console.warn(`No config found for docType: ${docType}`);
      return;
    }

    const key = config.key;
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;

    const file = event.target.files[0];
    if (!file) return;

    const newFileDetail = {
      name: file.name,
      size: file.size,
      file, // actual File object
    };

    setDocumentStates((prev) => ({
      ...prev,
      [selectedKey]: [newFileDetail],
    }));

    // Optional: reset the input so user can re-upload same file
    event.target.value = null;
  };

  const handleDeleteFile = (docType, index) => {
    const key = documentTypes[docType].key;
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;

    setDocumentStates((prev) => {
      const updatedFiles = (prev[selectedKey] || []).filter(
        (_, i) => i !== index
      );
      const newState = {
        ...prev,
        [selectedKey]: updatedFiles,
      };

      if (updatedFiles.length === 0) {
        newState[popupKey] = false;
      }

      return newState;
    });
  };

  const handleUploadClick = (docType, overrideConfig = null) => {
    const key = overrideConfig
      ? overrideConfig.key
      : documentTypes[docType]?.key;

    if (fileInputRefs[key] && fileInputRefs[key].current) {
      fileInputRefs[key].current.click();
    } else {
      console.warn(`No file input ref found for key: ${key}`);
    }
  };
  const getSelectedFiles = (docType, overrideConfig = null) => {
    if (overrideConfig) {
      // For dynamic tank uploads, use the config key directly
      const key = overrideConfig.key;
      const selectedKey = `selected${
        key.charAt(0).toUpperCase() + key.slice(1)
      }Files`;
      return documentStates[selectedKey] || [];
    } else {
      const key = documentTypes[docType].key;
      const selectedKey = `selected${
        key.charAt(0).toUpperCase() + key.slice(1)
      }Files`;
      return documentStates[selectedKey] || [];
    }
  };

  const getSelectedFilesMS = (docType, dynamicConfig = null) => {
    if (dynamicConfig) {
      // For dynamic BFT reports
      const dynamicKey = dynamicConfig.key;
      const selectedKey = `selected${
        dynamicKey.charAt(0).toUpperCase() + dynamicKey.slice(1)
      }Files`;
      return uploadStateMS[selectedKey] || [];
    } else {
      // For static documents
      const config = documentUploadMap.ms[docType];
      if (!config) return [];
      const selectedKey = `selected${
        config.key.charAt(0).toUpperCase() + config.key.slice(1)
      }Files`;
      return uploadStateMS[selectedKey] || [];
    }
  };
  const getSelectedFilesHSD = (docType, dynamicConfig = null) => {
    if (dynamicConfig) {
      // For dynamic BFT reports
      const dynamicKey = dynamicConfig.key;
      const selectedKey = `selected${
        dynamicKey.charAt(0).toUpperCase() + dynamicKey.slice(1)
      }Files`;
      return uploadStateHSD[selectedKey] || [];
    } else {
      // For static documents
      const config = documentUploadMap.hsd[docType];
      if (!config) return [];
      const selectedKey = `selected${
        config.key.charAt(0).toUpperCase() + config.key.slice(1)
      }Files`;
      return uploadStateHSD[selectedKey] || [];
    }
  };

  const documentUploadMap = {
    ms: {
      ms_load_port_test: {
        label: "Load Port Test Report",
        key: "msLoadPortTestReport",
      },
      ms_pd_test: { label: "PD Test", key: "msPdTest" },
      ms_bft_report: { label: "BFT Report", key: "msBftReport" },
    },
    hsd: {
      hsd_load_port_test: {
        label: "Load Port Test Report",
        key: "hsdLoadPortTestReport",
      },
      hsd_pd_test: { label: "PD Test", key: "hsdPdTest" },
      hsd_bft_report: { label: "BFT Report", key: "hsdBftReport" },
    },
  };

  const initProductUploadStates = (product) => {
    const states = {};
    const docs = documentUploadMap[product];
    Object.keys(docs).forEach((doc) => {
      const key = docs[doc].key;
      states[`selected${key.charAt(0).toUpperCase() + key.slice(1)}Files`] = [];
      states[
        `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`
      ] = false;
    });
    return states;
  };

  const [uploadStateMS, setUploadStateMS] = useState(
    initProductUploadStates("ms")
  );
  const [uploadStateHSD, setUploadStateHSD] = useState(
    initProductUploadStates("hsd")
  );

  const msRefs = {
    msLoadPortTestReport: useRef(null),
    msPdTest: useRef(null),
    msBftReport: useRef(null),
  };

  const hsdRefs = {
    hsdLoadPortTestReport: useRef(null),
    hsdPdTest: useRef(null),
    hsdBftReport: useRef(null),
  };

  const handleUploadFileInput = (
    product,
    docType,
    event,
    setState,
    overrideConfig = null
  ) => {
    const config = overrideConfig || documentUploadMap[product]?.[docType];

    if (!config?.key) {
      console.warn("Invalid config for docType:", docType);
      return;
    }

    const key = config.key;
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;

    const file = event.target.files[0];
    if (!file) return;

    const fileDetail = {
      name: file.name,
      size: file.size,
      file,
    };

    setState((prev) => ({
      ...prev,
      [selectedKey]: [fileDetail],
    }));

    // Clear input to allow re-uploading the same file
    event.target.value = null;
  };

  const removeUploadedFile = (
    product,
    docType,
    index,
    setState,
    overrideConfig = null
  ) => {
    const config = overrideConfig || documentUploadMap[product]?.[docType];

    if (!config?.key) {
      console.warn("Invalid config for docType:", docType);
      return;
    }

    const key = config.key;
    const fileKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;

    setState((prev) => {
      const newFiles = (prev[fileKey] || []).filter((_, i) => i !== index);
      const newState = { ...prev, [fileKey]: newFiles };
      if (newFiles.length === 0) newState[popupKey] = false;
      return newState;
    });
  };

  const toggleUploadPopup = (
    product,
    docType,
    setState,
    state,
    overrideConfig = null
  ) => {
    const config = overrideConfig || documentUploadMap[product]?.[docType];

    if (!config?.key) {
      console.warn("Missing config for docType:", docType);
      return;
    }

    const key = config.key;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;

    setState({
      ...state,
      [popupKey]: !state[popupKey],
    });
  };

  const renderFileUploadField = (
    product,
    docType,
    refs,
    state,
    setState,
    overrideConfig = null
  ) => {
    const config = overrideConfig || documentUploadMap[product]?.[docType];
    if (!config?.key) {
      console.warn("Missing config for docType:", docType);
      return null;
    }

    const key = config.key;
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;
    const files = state[selectedKey] || [];

    // Create dynamic ref for tank upload
    if (overrideConfig && !refs[key]) {
      refs[key] = React.createRef();
    }

    return (
      <div className="upload-section form-group" key={docType}>
        <label htmlFor={`${key}-input`} className="upload-label">
          {config.label}:
        </label>

        <div className="upload-controls">
          <button
            type="button"
            className="challan-btn"
            onClick={() => refs[key]?.current?.click()}
          >
            <FiUpload className="upload-icon" /> Upload File
          </button>

          <input
            id={`${key}-input`}
            type="file"
            ref={refs[key]}
            className="upload-hidden-input"
            onChange={(e) =>
              handleUploadFileInput(
                product,
                docType,
                e,
                setState,
                overrideConfig
              )
            }
            multiple
          />

          {files.length > 0 && (
            <span
              className="inquiry-file-btn"
              onClick={() =>
                toggleUploadPopup(
                  product,
                  docType,
                  setState,
                  state,
                  overrideConfig
                )
              }
            >
              <MdAttachFile className="file-icon" /> {files.length}
            </span>
          )}
        </div>

        {state[popupKey] && (
          <div className="attachment-popup" ref={popupRef}>
            <div className="popup-content">
              <div className="popup-header">
                <h4 className="popup-title">Attachments</h4>
                <button
                  className="popup-close-btn"
                  onClick={() =>
                    toggleUploadPopup(
                      product,
                      docType,
                      setState,
                      state,
                      overrideConfig
                    )
                  }
                >
                  <IoCloseOutline className="close-icon" />
                </button>
              </div>
              <div className="popup-body">
                {files.map((file, index) => (
                  <div className="file-item" key={index}>
                    <div className="file-info">
                      <p className="file-name">{file.name}</p>
                      <p className="file-size">
                        {(file.size / 1024).toFixed(2)} KB
                      </p>
                    </div>
                    <div className="file-actions">
                      <Tooltip title="Delete" arrow>
                        <button
                          className="file-action-btn remove-btn"
                          onClick={() =>
                            removeUploadedFile(
                              product,
                              docType,
                              index,
                              setState,
                              overrideConfig
                            )
                          }
                        >
                          <MdDeleteOutline className="action-icon" />
                        </button>
                      </Tooltip>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const documentUploadMapCommon = {
    travel: {
      tanker_load_port_doc: {
        label: "Travel Load Port Doc",
        key: "travelLoadPortDoc",
      },
    },
    tanker: {
      tanker_docs: {
        label: "Tanker Documentation",
        key: "tankerDocumentation",
      },
    },
  };

  const initProductUploadStatesCommon = (product) => {
    const states = {};
    const docs = documentUploadMapCommon[product];
    Object.keys(docs).forEach((doc) => {
      const key = docs[doc].key;
      states[`selected${key.charAt(0).toUpperCase() + key.slice(1)}Files`] = [];
      states[
        `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`
      ] = false;
    });
    return states;
  };

  const [uploadStateTravel, setUploadStateTravel] = useState(
    initProductUploadStatesCommon("travel")
  );
  const [uploadStateTanker, setUploadStateTanker] = useState(
    initProductUploadStatesCommon("tanker")
  );

  const travelRefs = {
    travelLoadPortDoc: useRef(null),
  };
  const tankerRefs = {
    tankerDocumentation: useRef(null),
  };

  const handleSingleUploadInput = (product, docType, event, setState) => {
    const file = event.target.files[0];
    if (!file) return;

    const key = documentUploadMapCommon[product][docType].key;
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;

    const fileDetail = {
      name: file.name,
      size: file.size,
      file,
    };

    // ✅ Overwrite instead of appending
    setState((prev) => ({
      ...prev,
      [selectedKey]: [fileDetail],
    }));
  };

  const removeSingleUploadedFile = (product, docType, index, setState) => {
    const key = documentUploadMapCommon[product][docType].key;
    const fileKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;

    setState((prev) => {
      const newFiles = (prev[fileKey] || []).filter((_, i) => i !== index);
      const newState = { ...prev, [fileKey]: newFiles };
      if (newFiles.length === 0) newState[popupKey] = false;
      return newState;
    });
  };

  const toggleSingleUploadPopup = (product, docType, setState, state) => {
    const key = documentUploadMapCommon[product][docType].key;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;
    setState({ ...state, [popupKey]: !state[popupKey] });
  };

  const renderSingleFileUpload = (product, docType, refs, state, setState) => {
    const config = documentUploadMapCommon[product][docType];
    const key = config.key;
    const selectedKey = `selected${
      key.charAt(0).toUpperCase() + key.slice(1)
    }Files`;
    const popupKey = `is${key.charAt(0).toUpperCase() + key.slice(1)}PopupOpen`;

    const files = state[selectedKey] || [];

    return (
      <div className=" form-group" key={docType}>
        <label htmlFor={`${key}-input`} className="upload-label">
          {config.label}:
        </label>

        <div className="upload-controls">
          <button
            type="button"
            className="challan-btn"
            onClick={() => refs[key]?.current?.click()}
          >
            <FiUpload className="upload-icon" /> Upload File
          </button>

          <input
            id={`${key}-input`}
            type="file"
            ref={refs[key]}
            className="upload-hidden-input"
            onChange={(e) =>
              handleSingleUploadInput(product, docType, e, setState)
            }
          />

          {files.length > 0 && (
            <span
              className="inquiry-file-btn"
              onClick={() =>
                toggleSingleUploadPopup(product, docType, setState, state)
              }
            >
              <MdAttachFile className="file-icon" /> {files.length}
            </span>
          )}
        </div>

        {state[popupKey] && (
          <div className="attachment-popup" ref={popupRef}>
            <div className="popup-content">
              <div className="popup-header">
                <h4 className="popup-title">Attachments</h4>
                <button
                  className="popup-close-btn"
                  onClick={() =>
                    toggleSingleUploadPopup(product, docType, setState, state)
                  }
                >
                  <IoCloseOutline className="close-icon" />
                </button>
              </div>
              <div className="popup-body">
                {files.map((file, index) => (
                  <div className="file-item" key={index}>
                    <div className="file-info">
                      <p className="file-name">{file.name}</p>
                      <p className="file-size">
                        {(file.size / 1024).toFixed(2)} KB
                      </p>
                    </div>
                    <div className="file-actions">
                      <Tooltip title="Delete" arrow>
                        <button
                          className="file-action-btn remove-btn"
                          onClick={() =>
                            removeSingleUploadedFile(
                              product,
                              docType,
                              index,
                              setState
                            )
                          }
                        >
                          <MdDeleteOutline className="action-icon" />
                        </button>
                      </Tooltip>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content" ref={containerRef}>
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">New Voyage</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <form className="form-detail" onKeyDown={handleKeyDown}>
              <div className="new-data-form">
                <div className="">
                  <div className="form-group">
                    <label htmlFor="voyage_number">
                      Voyage Number<span className="text-danger">*</span>
                    </label>
                    <div className="">
                      <input
                        type="text"
                        name="voyage_number"
                        value={voyageData.voyage_number}
                        onChange={handleInputChange}
                        placeholder="Enter Voyage Number"
                        className="half-width-input"
                      />
                      {errors.voyage_number && (
                        <div className="error-message">
                          {errors.voyage_number}
                        </div>
                      )}
                    </div>
                    <div className="voyageform-date">
                      <DatePicker
                        selected={voyageData.date}
                        // onChange={(date) => setServiceDueDate(date)}
                        onChange={handleDateChange}
                        placeholderText="Select date"
                        dateFormat="dd/MM/yyyy"
                        isClearable
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        maxDate={today}
                        // className={
                        //   theme === "dark" ? "dark-theme-datepicker" : ""
                        // }
                        className={`${
                          theme === "dark" ? "dark-theme-datepicker" : ""
                        } half-width-input`}
                        style={{ marginLeft: "4rem" }}
                      />
                      {errors.date && (
                        <div className="error-message">{errors.date}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="trip_number">
                    Trip Number<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="trip_number"
                      value={voyageData.trip_number}
                      onChange={handleInputChange}
                      placeholder="Enter Trip Number"
                    />
                  </div>
                  {errors.trip_number && (
                    <div className="error-message">{errors.trip_number}</div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="doc_name"></label>
                  <div className="input-group">
                    <div className="error-messages125">
                      File size must be 10 MB or less.
                    </div>
                  </div>
                </div>
                {/* Travel Load Port Doc */}
                {renderSingleFileUpload(
                  "travel",
                  "tanker_load_port_doc",
                  travelRefs,
                  uploadStateTravel,
                  setUploadStateTravel
                )}
                {/* Tanker Documentation */}
                {renderSingleFileUpload(
                  "tanker",
                  "tanker_docs",
                  tankerRefs,
                  uploadStateTanker,
                  setUploadStateTanker
                )}
                <div className="checkbox-form-group ">
                  <label htmlFor="" className="checkbox-form-group-label">
                    Products in Voyage<span className="text-danger">*</span>
                  </label>

                  <div className="fuel-checkbox-group product_dflex">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="ATF"
                        checked={selectedFuels.ATF}
                        onChange={handleCheckboxChange}
                        className="voyage-checkbox"
                      />
                      ATF
                    </label>

                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="MS"
                        checked={selectedFuels.MS}
                        onChange={handleCheckboxChange}
                        className="voyage-checkbox"
                      />
                      MS
                    </label>

                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="HSD"
                        checked={selectedFuels.HSD}
                        onChange={handleCheckboxChange}
                        className="voyage-checkbox"
                      />
                      HSD
                    </label>
                  </div>

                  {errors.voyage_product && (
                    <div className="error-message">{errors.voyage_product}</div>
                  )}
                </div>
                {selectedFuels.ATF && (
                  <div className="product_dflex">
                    <div className="product_label">
                      <label htmlFor="">ATF Documents :</label>
                    </div>
                    <div style={{ width: "100%" }}>
                      {Object.keys(documentTypes).map((docType) => {
                        if (docType === "bft_report") {
                          return (
                            <React.Fragment key={docType}>
                              <div className="input-group-dropdown">
                                <Select
                                  id="TagNo"
                                  options={tagOptions}
                                  value={selectedTagNo}
                                  onChange={handleTagNoChange}
                                  placeholder="Select Tank"
                                  isSearchable
                                  className="tank_dropdown"
                                />
                              </div>

                              {/* Display selected tags as chips - Keep your existing logic */}
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                  marginBottom: "15px",
                                }}
                              >
                                {addedTags.map((tag) => (
                                  <Chip
                                    key={tag.id}
                                    label={tag.tagNo}
                                    onDelete={() => handleRemoveTag(tag.id)}
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </div>

                              {/* Dynamic Upload Sections for Each Added Tank */}
                              {addedTags.map((tag) => {
                                const tankIdentifier = tag.tag_no || tag.id;
                                const tankDocType = `bft_report_${tankIdentifier}`;

                                const dynamicConfig = {
                                  key: `bftReport_${tankIdentifier}`, // Unique key for ref
                                  label: `BFT Report - ${tag.tagNo}`,
                                };

                                return (
                                  <div
                                    key={tankDocType}
                                    className="tank-specific-upload"
                                  >
                                    {renderUploadSection(
                                      tankDocType,
                                      dynamicConfig
                                    )}
                                  </div>
                                );
                              })}
                            </React.Fragment>
                          );
                        }

                        // Other document types - keep as is
                        return (
                          <React.Fragment key={docType}>
                            {renderUploadSection(docType)}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                )}

                {selectedFuels.MS && (
                  <div className="product_dflex">
                    <div className="product_label">
                      <label htmlFor="">MS Documents :</label>
                    </div>
                    <div style={{ width: "100%" }}>
                      {Object.keys(documentUploadMap.ms).map((docType) => {
                        if (docType === "ms_bft_report") {
                          return (
                            <React.Fragment key={docType}>
                              {/* Tank Selection Dropdown */}
                              <div className="input-group-dropdown">
                                <Select
                                  id="MSTagNo"
                                  options={tagOptionsMS}
                                  value={selectedTagNoMS}
                                  onChange={handleTagNoChangeMS}
                                  placeholder="Select Tank"
                                  isSearchable
                                  className="tank_dropdown"
                                />
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                  marginBottom: "15px",
                                }}
                              >
                                {addedTagsMS.map((tag) => (
                                  <Chip
                                    key={tag.id}
                                    label={tag.tagNo}
                                    onDelete={() => handleRemoveTagMS(tag.id)}
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </div>

                              {addedTagsMS.map((tag) => {
                                const tankIdentifier = tag.tag_no || tag.id;
                                const tankDocType = `ms_bft_report_${tankIdentifier}`;

                                const dynamicConfig = {
                                  key: `msBftReport_${tankIdentifier}`,
                                  label: `MS BFT Report - ${tag.tagNo}`,
                                };

                                return (
                                  <div
                                    key={tankDocType}
                                    className="tank-specific-upload"
                                  >
                                    {renderFileUploadField(
                                      "ms",
                                      tankDocType,
                                      msRefs,
                                      uploadStateMS,
                                      setUploadStateMS,
                                      dynamicConfig
                                    )}
                                  </div>
                                );
                              })}
                            </React.Fragment>
                          );
                        }

                        // Other MS document types - keep as is
                        return (
                          <React.Fragment key={docType}>
                            {renderFileUploadField(
                              "ms",
                              docType,
                              msRefs,
                              uploadStateMS,
                              setUploadStateMS
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                )}
                {selectedFuels.HSD && (
                  <div className="product_dflex">
                    <div className="product_label">
                      <label htmlFor="">HSD Documents :</label>
                    </div>
                    <div style={{ width: "100%" }}>
                      {Object.keys(documentUploadMap.hsd).map((docType) => {
                        if (docType === "hsd_bft_report") {
                          return (
                            <React.Fragment key={docType}>
                              <div className="input-group-dropdown">
                                <Select
                                  id="MSTagNo"
                                  options={tagOptionsHSD}
                                  value={selectedTagNoHSD}
                                  onChange={handleTagNoChangeHSD}
                                  placeholder="Select Tank"
                                  isSearchable
                                  className="tank_dropdown"
                                />
                              </div>

                              {/* Display selected tags as chips */}
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                  marginBottom: "15px",
                                }}
                              >
                                {addedTagsHSD.map((tag) => (
                                  <Chip
                                    key={tag.id}
                                    label={tag.tagNo}
                                    onDelete={() => handleRemoveTagHSD(tag.id)}
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))}
                              </div>
                              {addedTagsHSD.map((tag) => {
                                // Use tag_no or fallback to id for unique identification
                                const tankIdentifier = tag.tag_no || tag.id;
                                const tankDocType = `hsd_bft_report_${tankIdentifier}`;

                                const dynamicConfig = {
                                  key: `hsdBftReport_${tankIdentifier}`, // Unique key for ref
                                  label: `HSD BFT Report - ${tag.tagNo}`,
                                };

                                return (
                                  <div
                                    key={tankDocType}
                                    className="tank-specific-upload"
                                  >
                                    {renderFileUploadField(
                                      "hsd",
                                      docType,
                                      hsdRefs,
                                      uploadStateHSD,
                                      setUploadStateHSD,
                                      dynamicConfig
                                    )}
                                  </div>
                                );
                              })}
                            </React.Fragment>
                          );
                        }

                        // Other MS document types - keep as is
                        return (
                          <React.Fragment key={docType}>
                            {renderFileUploadField(
                              "hsd",
                              docType,
                              hsdRefs,
                              uploadStateHSD,
                              setUploadStateHSD
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-form-save-button"
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-form-cancel-button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default VoyageForm;
